import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import { ServerPath } from '../../Constant';
import { toast } from 'react-toastify';
import axios from 'axios';

const EditNotification = ({ show, onHide, templateData }) => {
    const [formData, setFormData] = useState({
        id: '',
        title: '',
        body: '',
        action_link: '',
        status: '',
        audience_selection: 'All',
        platform_targets: [],
        activity_range: '7',

    });

    const [isLoading, setIsLoading] = useState(false);
    const [stats, setStats] = useState([]);
    const [targetUser, setTargetUser] = useState(0);
    const fetchStats = async () => {
        try {
            const statsData = await axios.get(`${ServerPath}/admin-notification/stats`);
            console.log('stats data', statsData)
            if (statsData.data.success === 1) {
                setStats(statsData.data.data)
            }
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        fetchStats();
    }, [])

    // Initialize form when templateData is passed (from the list view)
    useEffect(() => {
        console.log(templateData)
        if (templateData) {
            // Logic to parse the audience_type string from DB back into UI state
            let selection = 'All';
            let platforms = [];
            let activity = '';

            if (templateData.audience_type.includes('Activity-')) {
                selection = 'Activity';
                activity = templateData.audience_type.split('-')[1];
            } else if (templateData.audience_type === 'iOS' || templateData.audience_type === 'Android' || templateData.audience_type.includes(',')) {
                selection = 'Platform';
                platforms = templateData.audience_type.split(',');
            }

            setFormData({
                id: templateData.notification_id,
                title: templateData.title || '',
                body: templateData.body || '',
                action_link: templateData.deep_link || '',
                status: templateData.status || 'New',
                audience_selection: selection,
                platform_targets: platforms,
                activity_range: activity
            });
            setTargetUser(templateData?.target_user)
        }
    }, [templateData, show]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const sanitizedValue = value
            .replace(/^\s+/g, '')        // Prevents starting with a space
            .replace(/\s{2,}/g, ' ');    // Replaces 2+ spaces with 1 space

        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
    };

    const handlePlatformChange = (platform, count) => {
        setFormData(prev => {
            const platforms = [...prev.platform_targets];
            if (platforms.includes(platform)) {
                setTargetUser(targetUser - count);
                return { ...prev, platform_targets: platforms.filter(p => p !== platform) };
            } else {
                setTargetUser(targetUser + count);
                return { ...prev, platform_targets: [...platforms, platform] };
            }
        });
    };

    const handleSubmit = async (status) => {
        // Validation
        if (!formData.title || !formData.body || !formData.action_link) {
            return toast.error("Please fill all required fields");
        }

        // BRD logic check: Published records shouldn't be edited
        if (templateData.status === 'Published' || templateData.status === 'RePublished') {
            return toast.error("Published notifications cannot be modified.");
        }

        // Format audience_type for database
        let audienceType = formData.audience_selection;
        if (audienceType === 'Platform') audienceType = formData.platform_targets.join(',');
        if (audienceType === 'Activity') audienceType = `Activity-${formData.activity_range}`;

        try {
            setIsLoading(true);
            const payload = {
                id: templateData.id,
                notification_id: templateData.notification_id,
                title: formData.title,
                body: formData.body,
                deep_link: formData.action_link,
                audience_type: audienceType,
                status: status,
                target_user: targetUser
            };

            const res = await axios.patch(`${ServerPath}/admin-notification`, payload);
            console.log('notification Response', res);
            if (res.data.success) {
                 {status === 'Success'? toast.success(`Notification Published successfully`): toast.success(`Notification ${status} successfully`)}
                                {status === 'Success' && toast.success(`Notification sending to ${targetUser} user`);}
                                {status === 'Success' && setTimeout(() => {
                                    toast.success(`Notification delivered to ${targetUser} user`);
                                }, 5000);}
                onHide();
            }
        } catch (err) {
            toast.error(err.response?.data?.message || "Error updating notification");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="xl" centered>
            <Modal.Header closeButton>
                <Modal.Title style={{ fontWeight: '600' }}>Edit Notification Template</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '30px' }}>
                <Row>
                    {/* Left Column: Content */}
                    <Col md={7}>
                        <Form.Group className="mb-4">
                            <Form.Label>Title <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                name="title"
                                maxLength={30}
                                value={formData.title}
                                onChange={handleInputChange}
                                disabled={templateData.status === 'Published' || templateData.status === 'Success'}
                            />
                            <div className="text-end small text-muted">{formData.title.length}/30</div>
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label>Text <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={4}
                                name="body"
                                maxLength={100}
                                value={formData.body}
                                onChange={handleInputChange}
                                disabled={templateData.status === 'Published' || templateData.status === 'Success'}
                            />
                            <div className="text-end small text-muted">{formData.body.length}/100</div>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Action Link / URL <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                name="action_link"
                                value={formData.action_link}
                                onChange={handleInputChange}
                                disabled={templateData.status === 'Published' || templateData.status === 'Success'}
                            />
                        </Form.Group>
                    </Col>

                    {/* Right Column: Status & Targeting */}
                    <Col md={5} className="ps-5 border-start">
                        <Form.Group className="mb-4">
                            <Form.Label className="fw-bold">Status</Form.Label>
                            <Form.Select
                                name="status"
                                value={formData.status}
                                onChange={handleInputChange}
                                style={{ border: '1px solid #5662F6' }}
                                disabled
                            >
                                <option value="New">New</option>
                                <option value="Draft">Draft</option>
                                <option value="Published">Published</option>
                                <option value="Success">Success</option>
                            </Form.Select>
                        </Form.Group>

                        <Form.Label className="fw-bold">Target User</Form.Label>
                        <Form.Check
                            type="radio" label={`All Registered (${stats?.total_notifiable_users})`} name="audience"
                            checked={formData.audience_selection === 'All'}
                            onChange={() => { setFormData({ ...formData, audience_selection: 'All', activity_range: '', platform_targets: [] }); setTargetUser(stats?.total_notifiable_users) }}
                            disabled={templateData.status === 'Published' || templateData.status === 'Success'}
                        />

                        <Form.Check
                            type="radio" label="By Platform" className="mt-2" name="audience"
                            checked={formData.audience_selection === 'Platform'}
                            onChange={() => { setFormData({ ...formData, audience_selection: 'Platform', activity_range: '' }); setTargetUser(0) }}
                            disabled={templateData.status === 'Published' || templateData.status === 'Success'}
                        />
                        <div className="ms-4" disabled={templateData.status === 'Published' || templateData.status === 'Success'}>
                            <Form.Check
                                type="checkbox" label={`iOS Users (${stats?.ios_users})`}
                                checked={formData.platform_targets.includes('iOS')}
                                disabled={formData.audience_selection !== 'Platform' || templateData.status === 'Published' || templateData.status === 'Success'}
                                onChange={() => handlePlatformChange('iOS', stats?.ios_users)}

                            />
                            <Form.Check
                                type="checkbox" label={`Android Users (${stats?.android_users})`}
                                checked={formData.platform_targets.includes('Android')}
                                disabled={formData.audience_selection !== 'Platform' || templateData.status === 'Published' || templateData.status === 'Success'}
                                onChange={() => handlePlatformChange('Android', stats?.android_users)}
                            />
                        </div>

                        <Form.Check
                            type="radio" label="By Activity" className="mt-2" name="audience"
                            checked={formData.audience_selection === 'Activity'}
                            onChange={() => { setFormData({ ...formData, audience_selection: 'Activity', platform_targets: [] }); setTargetUser(0) }}
                            disabled={templateData.status === 'Published' || templateData.status === 'Success'}
                        />
                        <div className="ms-4" disabled={templateData.status === 'Published' || templateData.status === 'Success'}>

                            <Form.Check
                                key={'7'} type="radio" label={`Active in Last 7 Days (${stats?.active_notifiable_7_days})`} name="activity"
                                checked={formData.activity_range === '7'}
                                disabled={formData.audience_selection !== 'Activity' || templateData.status === 'Published' || templateData.status === 'Success'}
                                onChange={() => { setFormData({ ...formData, activity_range: '7' }); setTargetUser(stats?.active_notifiable_7_days) }}
                            />
                            <Form.Check
                                key={'30'} type="radio" label={`Active in Last 30 Days (${stats?.active_notifiable_30_days})`} name="activity"
                                checked={formData.activity_range === '30'}
                                disabled={formData.audience_selection !== 'Activity' || templateData.status === 'Published' || templateData.status === 'Success'}
                                onChange={() => { setFormData({ ...formData, activity_range: '30' }); setTargetUser(stats?.active_notifiable_30_days) }}
                            />
                            <Form.Check
                                key={'60'} type="radio" label={`Active in Last 60 Days (${stats?.active_notifiable_60_days})`} name="activity"
                                checked={formData.activity_range === '60'}
                                disabled={formData.audience_selection !== 'Activity' || templateData.status === 'Published' || templateData.status === 'Success'}
                                onChange={() => { setFormData({ ...formData, activity_range: '60' }); setTargetUser(stats?.active_notifiable_60_days) }}
                            />

                        </div>
                        <Form.Check type="radio"
                            label="Only user with :" className="mt-2" name="audience"
                            checked={false}
                            disabled />
                        <div className="ms-4">
                            <Form.Check type="checkbox"
                                label="Location"
                                checked={false}
                                disabled />
                            <Form.Check type="checkbox"
                                label="App Version"
                                checked={false}
                                disabled />
                            <Form.Check type="checkbox"
                                label="Language preference"
                                checked={false}
                                disabled />
                        </div>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer className="border-0">
                {(templateData.status === 'Published' || templateData.status === 'Success') && <Button variant="secondary" onClick={onHide}>Cancel</Button>}
                {(templateData.status !== 'Published' && templateData.status !== 'Success') && <Button
                    style={{ backgroundColor: '#5662F6', border: 'none', padding: '10px 40px' }}
                    onClick={() => handleSubmit('Draft')}
                    disabled={isLoading}
                >
                    Update
                </Button>}
                {(templateData.status !== 'Published' && templateData.status !== 'Success') && <Button
                    style={{ backgroundColor: '#5662F6', border: 'none', padding: '10px 40px' }}
                    onClick={() => handleSubmit('Success')}
                    disabled={isLoading}
                >
                    {isLoading ? 'Publishing...' : 'Publish'}
                </Button>}
            </Modal.Footer>
        </Modal>
    );
};

export default EditNotification;